import React from 'react';
import PropTypes from 'prop-types';
import Divider from 'components/common/Divider';
import useAuth from 'hooks/useAuth';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SocialAuthButtons from './SocialAuthButtons';

const LoginForm = ({ hasLabel }) => {
 const { handleFieldChange, handleSubmit, formData } = useAuth('signin', {
  email: '',
  password: '',
  remember: false
 });

 return (
  <Form onSubmit={handleSubmit}>
   <Form.Group className="mb-3">
    {hasLabel && <Form.Label>Email</Form.Label>}
    <Form.Control
     placeholder={!hasLabel ? 'Email' : ''}
     value={formData.email}
     name="email"
     onChange={handleFieldChange}
     type="email"
    />
   </Form.Group>

   <Form.Group className="mb-3">
    {hasLabel && <Form.Label>Contraseña</Form.Label>}
    <Form.Control
     placeholder={!hasLabel ? 'Contraseña' : ''}
     value={formData.password}
     name="password"
     onChange={handleFieldChange}
     type="password"
    />
   </Form.Group>

   <Row className="justify-content-between align-items-center">
    <Col xs="auto">
     <Form.Check type="checkbox" id="rememberMe" className="mb-0">
      <Form.Check.Input type="checkbox" name="remember" checked={formData.remember} onChange={handleFieldChange} />
      <Form.Check.Label className="mb-0 text-700">Recordar mi sesión</Form.Check.Label>
     </Form.Check>
    </Col>

    <Col xs="auto">
     <Link className="fs--1 mb-0" to={`/authentication/card/forgot-password`}>
      ¿Olvido su contraseña?
     </Link>
    </Col>
   </Row>

   <Form.Group>
    <Button type="submit" color="primary" className="mt-3 w-100" disabled={!formData.email || !formData.password}>
     Ingresar
    </Button>
   </Form.Group>

   <Divider className="mt-4">Ingresar con</Divider>

   <SocialAuthButtons />
  </Form>
 );
};

LoginForm.propTypes = {
 layout: PropTypes.string,
 hasLabel: PropTypes.bool
};

LoginForm.defaultProps = {
 layout: 'simple',
 hasLabel: false
};

export default LoginForm;
